import axios from 'axios';

export const getTraceById = (id, date, utcOffsetMinutes, source) => {
	let options = {
		start: date,
		utcOffsetMinutes: utcOffsetMinutes,
	};

	return axios.post(`/TrackingHistories/${id}/track/`, options, source);
};

export const getEventsById = (id, date, utcOffsetMinutes, accountId, source) => {
	let options = {
		start: date,
		utcOffsetMinutes,
		accountId,
	};

	return axios.post(`/TrackingHistories/${id}/events/`, options, source);
};
